<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},
		watch: {
			"data.value": {
				handler(value) {
					if(value) this.data.error = false;
					else this.data.error = true;
				},
				deep: true,
			}
		}
	}
</script>

<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>
		<v-select
			:options="data.options"
			v-model="data.value"
			placeholder="Seleccionar"
			class="vue-select"
			:class="{ 'vue-select-invalid': data.error && errorForm }"
			:clearable="false"
		>
		</v-select>
	</div>
</template>